import React from 'react';
import { useTranslation } from 'react-i18next';

import PrimaryButton from 'components/layout/buttons/PrimaryButton';
import translations from 'services/translations/translations';

import 'style/layout/Buttons.css';

const SwitchInsideOutside = ({
  actionTriggeredCallback,
}: {
  actionTriggeredCallback: () => void;
}): JSX.Element | null => {
  const { t } = useTranslation([translations.common]);

  const switchInsideOutside = () => {
    window.SwitchInsideOutside();
    actionTriggeredCallback();
  };

  return (
    <PrimaryButton className="button-long-text" onClick={switchInsideOutside}>
      {t(`${translations.common}:Switch Inside/Outside`).toLocaleUpperCase()}
    </PrimaryButton>
  );
};

export default SwitchInsideOutside;
